// Sidebar handling functionality
export const initSidebar = () => {
  const sidebar = document.querySelector('.sidebar');
  const mainContent = document.querySelector('.main-content');
  const sidebarToggle = document.getElementById('sidebar-toggle');
  const overlay = document.querySelector('.sidebar-overlay');

  const cleanupSubmenusForMiniSidebar = () => {
    const navItems = document.querySelectorAll('.nav-tree .has-submenu.open');
    navItems.forEach((item) => {
      item.classList.remove('open');
    });
  };

  const toggleSidebar = () => {
    if (window.innerWidth <= 1200) {
      // Mobile: open/close sidebar with overlay
      sidebar?.classList.toggle('open');
      overlay?.classList.toggle('show');
    } else {
      // Desktop: toggle sidebar mini
      sidebar?.classList.toggle('sidebar-mini');
      mainContent?.classList.toggle('expanded-mini');

      // Remove 'open' class if present
      sidebar?.classList.remove('open');

      // Save mini state
      localStorage.setItem('sidebar-mini', sidebar?.classList.contains('sidebar-mini') ? 'true' : 'false');

      // Clean up submenu states only if mini is active
      if (sidebar?.classList.contains('sidebar-mini')) {
        cleanupSubmenusForMiniSidebar();
      }
    }
  };

  // Reset sidebar state on resize
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1200) {
      // Remove desktop-only states
      sidebar?.classList.remove('sidebar-mini');
      mainContent?.classList.remove('expanded-mini');
    } else {
      // Remove mobile-only states
      sidebar?.classList.remove('open');
      overlay?.classList.remove('show');
    }
  });

  // Event listeners
  sidebarToggle?.addEventListener('click', toggleSidebar);
  overlay?.addEventListener('click', toggleSidebar);

  // Apply initial sidebar state if html has the initial class
  if (document.documentElement.classList.contains('sidebar-mini-initial')) {
    sidebar?.classList.add('sidebar-mini');
    mainContent?.classList.add('expanded-mini');

    // Clean up any submenu states that were hidden by CSS to prevent issues
    // when transitioning out of mini mode later
    setTimeout(() => {
      cleanupSubmenusForMiniSidebar();
    }, 0);

    // Remove the initial class as it's no longer needed
    document.documentElement.classList.remove('sidebar-mini-initial');
  }
};
